export const ACCESS_TOKEN_STORED = 'tokenHandling/ACCESS_TOKEN_STORED';

export const accessTokenStored = token => ({
    payload: token,
    type: ACCESS_TOKEN_STORED,
});
